<template>
    <div class="px-4 md:px-6 pb-10 max-w-screen-3xl mx-auto">
        <slot />
    </div>
</template>

<script setup lang="ts">

</script>